import React, { useEffect, useState } from "react";
import Storage from "../../services/storage.service";
import SpinnerTimeLoader from "./timeLoading";

let subscriptions = [];
const ScreenLoader = () => {
    const [bizConfigLoading, setBizConfigLoading] = useState(false);
    const [themeLoading, setThemeLoading] = useState(false);
    const [securityManagementLoading, setSecurityManagementLoading] = useState(false);
    const [graphLoading, setGraphLoading] = useState(false);
    const [translationLoading, setTranslationLoading] = useState(false);

    useEffect(() => {
        subscriptions.push(
            Storage.get_obsrv("bizConfigLoading").subscribe((data) => {
                setBizConfigLoading(data);
            })
        );
        subscriptions.push(
            Storage.get_obsrv("themeLoading").subscribe((data) => {
                setThemeLoading(data);
            })
        );
        subscriptions.push(
            Storage.get_obsrv("securityManagementLoading").subscribe((data) => {
                setSecurityManagementLoading(data);
            })
        );
        subscriptions.push(
            Storage.get_obsrv("graphLoading").subscribe((data) => {
                setGraphLoading(data);
            })
        );
        subscriptions.push(
            Storage.get_obsrv("translationLoading").subscribe((data) => {
                setTranslationLoading(data);
            })
        );

        return () => {
            if (subscriptions && subscriptions?.length) {
                for (let subscription of subscriptions) {
                    subscription.unsubscribe();
                }
            }
        }
    }, [])

    return (
        (bizConfigLoading || themeLoading || securityManagementLoading || graphLoading || translationLoading) &&
        <>
            <div className='screen-loader'>
                <div className='screen-loader-container'>
                    <SpinnerTimeLoader />
                </div>
            </div>
        </>

    );
};

export default ScreenLoader;